import I18nComponent from './I18nComponent';


export default I18nComponent;
